/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Summary_TitleInputs */



/**
* | output |
* | --- |
* | "Export Summary" |
*
* @param {Image_Export_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_title = /** @type {((inputs?: Image_Export_Summary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resume de l'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportübersicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riepilogo esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сводка по экспорту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resumen de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出摘要")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートの概要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात सारांश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resumo da Exportação")
	return /** @type {LocalizedString} */ ("Export Summary")
});